import React from 'react';
import {Box, Card, Container, Link, Stack, Typography, useTheme} from '@mui/material';

import NotFoundImg from 'presentation/assets/images/general-lost.svg';
import {translations} from 'presentation/translations-new';
import {useMediaQueries} from 'presentation/pages';
import {useHostName} from 'presentation/hooks';
import {MainHeader} from '../MainHeader';
import {MainFooter} from '../MainFooter';

const {description, title, portalAccess, subDescription, descriptionMobile1, descriptionMobile2} =
	translations['pt-br'].others.inMaintenance;

export function MaintenancePage() {
	const {isMobile} = useMediaQueries();
	const {palette} = useTheme();
	const {
		dataHostNameState: {
			links: {SITE},
		},
	} = useHostName();

	return (
		<Stack height="100vh">
			<MainHeader variant="maintenance" />
			<Container sx={{mt: 4, flex: 1}} maxWidth="md">
				<Card
					elevation={0}
					sx={{
						padding: 3,
					}}>
					<Stack
						gap={2}
						flexDirection={isMobile ? 'column' : 'row'}
						alignItems={isMobile ? 'flex-start' : 'center'}>
						<Stack gap={isMobile ? 2 : 4} maxWidth={394}>
							<Stack gap={2}>
								<Typography variant="h6" color="text.primary">
									{title}
								</Typography>
								{isMobile ? (
									<Stack>
										<Typography color={palette.customInfo.shades?.['160p']}>
											{descriptionMobile1}
										</Typography>
										<Typography color={palette.customInfo.shades?.['160p']}>
											{descriptionMobile2}
										</Typography>
									</Stack>
								) : (
									<Typography color={palette.customInfo.shades?.['160p']}>
										{description}
									</Typography>
								)}
							</Stack>
							<Stack gap={1}>
								<Typography
									fontSize="0.75rem"
									fontWeight={600}
									color={palette.customInfo.shades?.['160p']}>
									{subDescription}
								</Typography>
								<Typography fontSize="0.75rem" color="text.secondary">
									{portalAccess} <br />
									<Link href={SITE} sx={{color: palette.primary.main}}>
										{SITE}
									</Link>
								</Typography>
							</Stack>
						</Stack>
						<Box maxHeight={280} maxWidth={280} marginInline="auto">
							<img src={NotFoundImg} alt={title} width="100%" />
						</Box>
					</Stack>
				</Card>
			</Container>
			<MainFooter customMarginBottom="16px" />
		</Stack>
	);
}
